/**
 * 愛情計算器資料庫
 */

export const LOVE_QUOTES = {
  zh: [
    "真正的愛情，是在一起時能感到幸福，分開時能感到思念，但不會因為思念而痛苦。",
    "我們在愛情裡不斷成長，不因歲月而改變的是我對你的愛。",
    "愛就是在對的時間，遇見對的人，心有靈犀。",
    "我想陪你走過漫長歲月，做你一生的守護。",
    "每一天醒來，感謝有你在我身邊，讓平凡的日子變得美好。",
    "我不需要轟轟烈烈的愛情，只要平平淡淡的陪伴。",
    "最好的愛情，就是兩個人互相陪伴，共同成長。",
    "我的心中，你永遠是最重要的那個人。",
    "愛情不是尋找一個完美的人，而是學會用完美的眼光，欣賞一個不完美的人。",
    "與你相伴的每一天，都是我生命中最珍貴的時光。",
    "愛情是兩顆心靈的共鳴，是彼此的靈魂伴侶。",
    "時間會沖淡一切，唯獨對你的愛，越陳越香。",
    "你的出現，讓我相信緣分和永恆。",
    "每一次看到你的笑容，都是我生活中最美好的時刻。",
    "愛你是我做過最正確的決定。"
  ],
  en: [
    "True love is feeling happiness when together, missing when apart, but not suffering from the longing.",
    "We grow in love, and what doesn't change with time is my love for you.",
    "Love is meeting the right person at the right time, with hearts that connect.",
    "I want to walk with you through the long years, being your lifelong guardian.",
    "Every morning I wake up grateful to have you by my side, making ordinary days beautiful.",
    "I don't need passionate love, just quiet companionship.",
    "The best love is when two people accompany each other and grow together.",
    "In my heart, you will always be the most important person.",
    "Love isn't about finding a perfect person, but learning to see an imperfect person perfectly.",
    "Every day spent with you is the most precious time in my life.",
    "Love is the harmony of two souls, finding their soulmate in each other.",
    "Time may fade everything, except my love for you, which grows richer with age.",
    "Your presence makes me believe in destiny and eternity.",
    "Each time I see your smile is the most beautiful moment in my life.",
    "Loving you is the best decision I've ever made."
  ]
};

export const LOVE_ACHIEVEMENTS = {
  zh: [
    { id: 'first-day',           days: 1,     name: '愛的初體驗',       description: '在一起的第一天',         icon: '💓' },
    { id: 'first-week',          days: 7,     name: '愛情第一週',       description: '甜蜜的第一週',           icon: '💕' },
    { id: 'two-weeks',           days: 14,    name: '兩週甜蜜',         description: '兩週的溫馨時光',         icon: '💞' },
    { id: 'first-month',         days: 30,    name: '愛情第一月',       description: '與你共度的第一個月',     icon: '💗' },
    { id: 'fifty-days',          days: 50,    name: '甜蜜50天',         description: '50天的愛情旅程',         icon: '💘' },
    { id: 'two-months',          days: 60,    name: '兩月之約',         description: '愛情持續兩個月',         icon: '💓' },
    { id: 'ninety-days',         days: 90,    name: '九十天愛戀',       description: '愛情進入第三個月',       icon: '💝' },
    { id: 'hundred-days',        days: 100,   name: '百日紀念',         description: '愛情的百日里程碑',       icon: '💖' },
    { id: 'half-year',           days: 183,   name: '半年之愛',         description: '堅持了半年的愛情',       icon: '🥂' },
    { id: 'first-year',          days: 365,   name: '愛情週年',         description: '一週年!值得慶祝',        icon: '🎂' },
    { id: 'five-twenty',         days: 520,   name: '我愛你',           description: '520天的愛的告白',        icon: '💌', special: true },
    { id: 'two-years',           days: 730,   name: '兩年之約',         description: '兩年的愛的旅程',         icon: '🎉' },
    { id: 'thousand-days',       days: 1000,  name: '千日紀念',         description: '千日相守的愛情',         icon: '🌟' },
    { id: 'one-three-one-four',  days: 1314,  name: '一生一世',         description: '1314天的永恆之愛',       icon: '💖', special: true },
    { id: 'three-years',         days: 1095,  name: '三年甜蜜',         description: '三年的甜蜜陪伴',         icon: '🎊' },
    { id: 'five-years',          days: 1825,  name: '五年之愛',         description: '五年的成長與愛',         icon: '💎' },
    { id: 'two-two-two-two',     days: 2222,  name: '愛你愛你愛你愛你', description: '2222天的愛的告白',       icon: '💝', special: true },
    { id: 'three-three-three-three', days: 3333, name: '三生三世',      description: '3333天的三生三世之約',   icon: '🌈', special: true },
    { id: 'ten-years',           days: 3650,  name: '十年之約',         description: '十年風雨同舟',           icon: '👑' },
    { id: 'five-two-zero-zero',  days: 5200,  name: '我愛你 千萬次',   description: '5200天的深情告白',       icon: '💌', special: true },
    { id: 'fifteen-years',       days: 5475,  name: '十五年之愛',       description: '十五年的甜蜜與堅持',     icon: '🏆' },
    { id: 'six-six-six-six',     days: 6666,  name: '六六大順',         description: '6666天的幸福順遂',       icon: '🍀', special: true },
    { id: 'twenty-years',        days: 7300,  name: '廿載同心',         description: '二十年的相守相伴',       icon: '👑' },
    { id: 'eight-eight-eight-eight', days: 8888, name: '幸福發發發發',  description: '8888天的幸福美滿',       icon: '🎊', special: true },
    { id: 'nine-nine-nine-nine', days: 9999,  name: '長長久久',         description: '9999天的愛的長久承諾',   icon: '🔥', special: true },
    { id: 'thirty-years',        days: 10950, name: '三十年之約',       description: '三十年的相伴相隨',       icon: '💎' },
    { id: 'fifty-years',         days: 18250, name: '金婚之喜',         description: '五十年的金婚紀念',       icon: '🏅', special: true }
  ],
  en: [
    { id: 'first-day',           days: 1,     name: 'First Love Day',          description: 'First day together',                          icon: '💓' },
    { id: 'first-week',          days: 7,     name: 'First Love Week',         description: 'Sweet first week',                             icon: '💕' },
    { id: 'two-weeks',           days: 14,    name: 'Two Weeks Together',      description: 'Two weeks of warmth',                          icon: '💞' },
    { id: 'first-month',         days: 30,    name: 'First Love Month',        description: 'First month together',                         icon: '💗' },
    { id: 'fifty-days',          days: 50,    name: 'Sweet 50 Days',           description: '50 days love journey',                         icon: '💘' },
    { id: 'two-months',          days: 60,    name: 'Two Months Journey',      description: 'Two months together',                          icon: '💓' },
    { id: 'ninety-days',         days: 90,    name: 'Ninety Days of Love',     description: 'Love into the third month',                    icon: '💝' },
    { id: 'hundred-days',        days: 100,   name: '100 Days Milestone',      description: '100 days of love',                             icon: '💖' },
    { id: 'half-year',           days: 183,   name: 'Half Year Love',          description: 'Half year of devotion',                        icon: '🥂' },
    { id: 'first-year',          days: 365,   name: 'Love Anniversary',        description: 'One year! Worth celebrating',                  icon: '🎂' },
    { id: 'five-twenty',         days: 520,   name: 'I Love You',              description: '520 days of love confession',                  icon: '💌', special: true },
    { id: 'two-years',           days: 730,   name: 'Two Years Journey',       description: 'Two years of love path',                       icon: '🎉' },
    { id: 'thousand-days',       days: 1000,  name: '1000 Days Milestone',     description: 'A thousand days together',                     icon: '🌟' },
    { id: 'one-three-one-four',  days: 1314,  name: 'Forever and Ever',        description: '1314 days of eternal love',                    icon: '💖', special: true },
    { id: 'three-years',         days: 1095,  name: 'Three Year Sweetness',    description: 'Three years of sweet companionship',           icon: '🎊' },
    { id: 'five-years',          days: 1825,  name: 'Five Years of Love',      description: 'Five years of growth and love',                icon: '💎' },
    { id: 'two-two-two-two',     days: 2222,  name: 'Love You Love You',       description: '2222 days of love confession',                 icon: '💝', special: true },
    { id: 'three-three-three-three', days: 3333, name: 'Lifetime Promise',     description: '3333 days of lifetime promise',                icon: '🌈', special: true },
    { id: 'ten-years',           days: 3650,  name: 'Ten Year Promise',        description: 'Ten years through thick and thin',             icon: '👑' },
    { id: 'five-two-zero-zero',  days: 5200,  name: 'I Love You x10',         description: '5200 days of deep affection',                  icon: '💌', special: true },
    { id: 'fifteen-years',       days: 5475,  name: 'Fifteen Years',           description: 'Fifteen years of sweetness and perseverance',  icon: '🏆' },
    { id: 'six-six-six-six',     days: 6666,  name: 'Smooth Sailing Love',     description: '6666 days of smooth happiness',                icon: '🍀', special: true },
    { id: 'twenty-years',        days: 7300,  name: 'Twenty Years United',     description: 'Twenty years of companionship',                icon: '👑' },
    { id: 'eight-eight-eight-eight', days: 8888, name: 'Prosperity Together',  description: '8888 days of abundant happiness',              icon: '🎊', special: true },
    { id: 'nine-nine-nine-nine', days: 9999,  name: 'Forever & Always',        description: '9999 days of everlasting love promise',        icon: '🔥', special: true },
    { id: 'thirty-years',        days: 10950, name: 'Thirty Year Covenant',    description: 'Thirty years of togetherness',                 icon: '💎' },
    { id: 'fifty-years',         days: 18250, name: 'Golden Anniversary',      description: 'Fifty years golden celebration',               icon: '🏅', special: true }
  ]
};

export const LOVE_MILESTONES = [
  1, 7, 14, 30, 50, 60, 90, 99, 100, 120, 183, 200, 222, 365,
  500, 520, 666, 730, 888, 999, 1000, 1095, 1314, 1825,
  2000, 2222, 3000, 3333, 3650, 4000, 5200, 5475, 6666,
  7300, 8888, 9999, 10000, 10950, 18250
];

export const SPECIAL_MILESTONES = [
  520,   // "I love you" (我愛你)
  1314,  // "Forever" (一生一世)
  2222,  // "Love you love you"
  3333,  // "Three lifetimes" (三生三世)
  5200,  // "I love you x10"
  6666,  // "Smooth sailing" (六六大順)
  8888,  // "Prosperity" (發發發發)
  9999   // "Forever and ever" (長長久久)
];

// 加回 MilestoneCard.jsx 需要用的分類數據
export const MILESTONE_CATEGORIES = {
  FIRST_MOMENTS: [1, 7, 14, 30],
  EARLY_JOURNEY: [50, 60, 90, 99, 100, 120, 183, 200, 222],
  YEARLY: [365, 730, 1095, 1825, 3650, 5475, 7300, 10950, 18250],
  NUMERIC_SPECIAL: [500, 666, 888, 999, 1000, 2000, 2222, 3000, 3333, 4000, 6666, 8888, 9999, 10000],
  CULTURAL_SPECIAL: [520, 1314, 5200]
};

// 加回 MilestoneCard.jsx 需要用的圖示數據
export const MILESTONE_ICONS = {
  1: '💓',
  7: '💕',
  14: '💞',
  30: '💗',
  50: '💘',
  60: '💓',
  90: '💝',
  99: '🌹',
  100: '💖',
  120: '✨',
  183: '🥂',
  200: '🌟',
  222: '🦢',
  365: '🎂',
  500: '💫',
  520: '💌',
  666: '🍀',
  730: '🎉',
  888: '🎊',
  999: '💍',
  1000: '👑',
  1095: '🎊',
  1314: '💖',
  1825: '💎',
  2000: '🌟',
  2222: '💝',
  3000: '🌺',
  3333: '🌈',
  3650: '👑',
  4000: '🌟',
  5200: '💌',
  5475: '🏆',
  6666: '🍀',
  7300: '👑',
  8888: '🎊',
  9999: '🔥',
  10000: '✨',
  10950: '💎',
  18250: '🏅',
  default: '❤️'
};